// source: pbtypes/vehicle/skills/builtin_skills/keyframe/keyframe.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_body_trans_pb = require('../../../../../pbtypes/gen/body/trans_pb.js');
goog.object.extend(proto, pbtypes_gen_body_trans_pb);
var pbtypes_gen_skills_keyframe_trans_pb = require('../../../../../pbtypes/gen/skills/keyframe_trans_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_keyframe_trans_pb);
goog.exportSymbol('proto.skills.KeyframeActionArgs', null, global);
goog.exportSymbol('proto.skills.KeyframeActionStateData', null, global);
goog.exportSymbol('proto.skills.KeyframeResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.KeyframeActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skills.KeyframeActionArgs.repeatedFields_, null);
};
goog.inherits(proto.skills.KeyframeActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.KeyframeActionArgs.displayName = 'proto.skills.KeyframeActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.KeyframeResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.KeyframeResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.KeyframeResultData.displayName = 'proto.skills.KeyframeResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.KeyframeActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.KeyframeActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.KeyframeActionStateData.displayName = 'proto.skills.KeyframeActionStateData';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skills.KeyframeActionArgs.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.KeyframeActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.KeyframeActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.KeyframeActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.KeyframeActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
keyframeListList: jspb.Message.toObjectList(msg.getKeyframeListList(),
    pbtypes_gen_skills_keyframe_trans_pb.KeyframeTrans.toObject, includeInstance),
speed: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
dynamicBraking: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
poseGraphLogDir: jspb.Message.getFieldWithDefault(msg, 4, ""),
navTTakeoff: (f = msg.getNavTTakeoff()) && pbtypes_gen_body_trans_pb.TransPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.KeyframeActionArgs}
 */
proto.skills.KeyframeActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.KeyframeActionArgs;
  return proto.skills.KeyframeActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.KeyframeActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.KeyframeActionArgs}
 */
proto.skills.KeyframeActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_skills_keyframe_trans_pb.KeyframeTrans;
      reader.readMessage(value,pbtypes_gen_skills_keyframe_trans_pb.KeyframeTrans.deserializeBinaryFromReader);
      msg.addKeyframeList(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSpeed(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDynamicBraking(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPoseGraphLogDir(value);
      break;
    case 5:
      var value = new pbtypes_gen_body_trans_pb.TransPb;
      reader.readMessage(value,pbtypes_gen_body_trans_pb.TransPb.deserializeBinaryFromReader);
      msg.setNavTTakeoff(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.KeyframeActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.KeyframeActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.KeyframeActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.KeyframeActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeyframeListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_skills_keyframe_trans_pb.KeyframeTrans.serializeBinaryToWriter
    );
  }
  f = message.getSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getDynamicBraking();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getPoseGraphLogDir();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNavTTakeoff();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      pbtypes_gen_body_trans_pb.TransPb.serializeBinaryToWriter
    );
  }
};


/**
 * repeated KeyframeTrans keyframe_list = 1;
 * @return {!Array<!proto.skills.KeyframeTrans>}
 */
proto.skills.KeyframeActionArgs.prototype.getKeyframeListList = function() {
  return /** @type{!Array<!proto.skills.KeyframeTrans>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_skills_keyframe_trans_pb.KeyframeTrans, 1));
};


/**
 * @param {!Array<!proto.skills.KeyframeTrans>} value
 * @return {!proto.skills.KeyframeActionArgs} returns this
*/
proto.skills.KeyframeActionArgs.prototype.setKeyframeListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.skills.KeyframeTrans=} opt_value
 * @param {number=} opt_index
 * @return {!proto.skills.KeyframeTrans}
 */
proto.skills.KeyframeActionArgs.prototype.addKeyframeList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.skills.KeyframeTrans, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.KeyframeActionArgs} returns this
 */
proto.skills.KeyframeActionArgs.prototype.clearKeyframeListList = function() {
  return this.setKeyframeListList([]);
};


/**
 * optional float speed = 2;
 * @return {number}
 */
proto.skills.KeyframeActionArgs.prototype.getSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.KeyframeActionArgs} returns this
 */
proto.skills.KeyframeActionArgs.prototype.setSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional bool dynamic_braking = 3;
 * @return {boolean}
 */
proto.skills.KeyframeActionArgs.prototype.getDynamicBraking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.KeyframeActionArgs} returns this
 */
proto.skills.KeyframeActionArgs.prototype.setDynamicBraking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string pose_graph_log_dir = 4;
 * @return {string}
 */
proto.skills.KeyframeActionArgs.prototype.getPoseGraphLogDir = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.KeyframeActionArgs} returns this
 */
proto.skills.KeyframeActionArgs.prototype.setPoseGraphLogDir = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional body.TransPb nav_T_takeoff = 5;
 * @return {?proto.body.TransPb}
 */
proto.skills.KeyframeActionArgs.prototype.getNavTTakeoff = function() {
  return /** @type{?proto.body.TransPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_body_trans_pb.TransPb, 5));
};


/**
 * @param {?proto.body.TransPb|undefined} value
 * @return {!proto.skills.KeyframeActionArgs} returns this
*/
proto.skills.KeyframeActionArgs.prototype.setNavTTakeoff = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.KeyframeActionArgs} returns this
 */
proto.skills.KeyframeActionArgs.prototype.clearNavTTakeoff = function() {
  return this.setNavTTakeoff(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.KeyframeActionArgs.prototype.hasNavTTakeoff = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.KeyframeResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.KeyframeResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.KeyframeResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.KeyframeResultData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.KeyframeResultData}
 */
proto.skills.KeyframeResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.KeyframeResultData;
  return proto.skills.KeyframeResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.KeyframeResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.KeyframeResultData}
 */
proto.skills.KeyframeResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.KeyframeResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.KeyframeResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.KeyframeResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.KeyframeResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.KeyframeActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.KeyframeActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.KeyframeActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.KeyframeActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.KeyframeActionStateData}
 */
proto.skills.KeyframeActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.KeyframeActionStateData;
  return proto.skills.KeyframeActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.KeyframeActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.KeyframeActionStateData}
 */
proto.skills.KeyframeActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.KeyframeActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.KeyframeActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.KeyframeActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.KeyframeActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
